export default __webpack_public_path__ + "paste-from-clipboard.png";